module.exports = __webpack_public_path__ + "static/media/CloudLeft.22281117.svg";